import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = { class: "card-outlined p-4 mb-4" }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_seminar_details_completed = _resolveComponent("seminar-details-completed")!
  const _component_seminar_details_body = _resolveComponent("seminar-details-body")!
  const _component_seminar_details_apply = _resolveComponent("seminar-details-apply")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.store.state.seminar.seminarDetails)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.store.state.seminar.seminarDetails.seminar_user ? `${_ctx.seminarTitle}${_ctx.t('seminar_details.title.confirm')}` : `${_ctx.seminarTitle}${_ctx.t('seminar_details.title.apply')}`), 1),
                  (_ctx.store.state.seminar.seminarDetails.seminar_user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_seminar_details_completed, {
                          seminarDetails: _ctx.store.state.seminar.seminarDetails
                        }, null, 8, ["seminarDetails"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_seminar_details_body, {
                      seminarDetails: _ctx.store.state.seminar.seminarDetails
                    }, null, 8, ["seminarDetails"])
                  ]),
                  (!_ctx.store.state.seminar.seminarDetails.seminar_user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_seminar_details_apply, {
                          seminarDetails: _ctx.store.state.seminar.seminarDetails
                        }, null, 8, ["seminarDetails"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" セミナー情報が見つかりませんでした。 ")
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}